<template>
    <div class="Background">
        <v-container fluid>
        <v-row no-gutters class="uniform-gap-32">
            <!-- 좌측 컬럼: 플레이어 + 소셜미디어 -->
            <v-col
                cols="12" md="7" xl="8" class="grid-col"
            >
            <!-- 플레이어 카드 -->
            <div class="video-container mb-4">
                <iframe
                    scrolling="no"
                    ref="iframe"
                    :src="EMBEDIEDURL"
                    frameborder="0"
                    allowfullscreen
                    @load="temp"
                    @playing="resizeVideo"
                ></iframe>
            </div>

            <!-- 플레이어 아래 새로고침/안내 -->
            <v-alert class="info_alert" type="info" dense text>
                <span>{{ $store.getters.t('새로고침 버튼을 눌러주셔야 라이브 방송이 스트림온에 반영됩니다.') }}</span>
                <template v-slot:append>
                    <v-btn small icon color="blue darken-2" @click="refreshIframe">
                    <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
            </v-alert>

            </v-col>

            <!-- 우측 컬럼: 스트리밍 상세 정보 + URL INFO -->
            <v-col
            cols="12" md="5" xl="4" class="grid-col"
            >
            <!-- 스트리밍 상세 정보 -->
            <v-card class="rounded-lg elevation-0 mb-6">
                <v-card-title class="py-4 d-flex justify-space-between py-4">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('스트리밍 상세 정보') }}</h3>
                    <div>
                        <TextButton :buttonText="$store.getters.t('목록')" @click="goLiveList()" class="mr-2"/>
                    </div>
                    </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="thead_custom_left thead_custom_top pa-3" style="height: 60px;">
                            {{ $store.getters.t('Live 스트리밍') }}
                        </th>
                        <th class="thead_custom_right thead_custom_top pa-3">
                            <span>
                            <Input placeholder="name" :value="displayStreamName" viewType="name" :disabled="true" />
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('Live 송출') }}
                        </th>
                        <th class="thead_custom_right pa-3">
                            <CustomSwitch :switchState="switchStates.publishing" :toggleSwitch="() => toggleSwitch('publishing')" />
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('레코딩') }}
                        </th>
                        <th class="thead_custom_right pa-3" style="display:flex;align-items:center;">
                            <CustomSwitch :switchState="switchStates.recording" :toggleSwitch="() => toggleSwitch('recording')" />
                            <span v-if="recorderState === 'stop'" class="reco_status recording_off">
                            <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                            {{ $store.getters.t('녹화 중이 아닙니다') }}
                            </span>
                            <span v-if="recorderState === 'progress'" class="reco_status recording_on">
                            <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                            {{ $store.getters.t('녹화 중입니다') }}
                            </span>
                            <span v-if="recorderState === 'wait'" class="reco_status recording_waiting">
                            <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333" />
                            {{ $store.getters.t('영상을 준비하는 중입니다') }}
                            </span>
                        </th>
                        </tr>
                    </thead>
                    </template>
                </v-simple-table>
                </v-card-text>
            </v-card>

            <!-- URL INFO -->
            <v-card class="rounded-lg elevation-0">
                <v-card-title class="py-4 d-flex justify-space-between align-center">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('INFO') }}</h3>
                    <TextButton
                    :buttonText="$store.getters.t('다운로드')"
                    iconColor="#555"
                    icon="mdi-download"
                    class="ml-2"
                    @click="downloadForm"
                    />
                </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">

                <!-- URL 항목들 -->
                <div class="url-info-list">

                    <!-- Playback URL -->
                    <div class="url-block">
                        <div class="url-label">{{ $store.getters.t('PLAYBACK URL') }}</div>
                        <div class="url-line">
                        <div class="url-text mono-ellipsis" :title="HLS">{{ HLS }}</div>
                        <v-btn icon color="#999" @click="copyToClipboard(HLS)">
                            <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                        </div>
                    </div>

                    <!-- Embedded URL -->
                    <div class="url-block">
                        <div class="url-label">{{ $store.getters.t('EMBEDDED URL') }}</div>
                        <div class="url-line">
                        <div class="url-text mono-ellipsis" :title="EMBEDIEDURL">{{ EMBEDIEDURL }}</div>
                        <v-btn icon color="#999" @click="copyToClipboard(EMBEDIEDURL)">
                            <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                        </div>
                    </div>

                    <!-- Thumbnail URL -->
                    <div class="url-block">
                        <div class="url-label">{{ $store.getters.t('THUMBNAIL URL') }}</div>
                        <div class="url-line">
                        <div class="url-text mono-ellipsis" :title="ThumbnailUrl">{{ ThumbnailUrl }}</div>
                        <v-btn icon color="#999" @click="copyToClipboard(ThumbnailUrl)">
                            <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                        </div>
                    </div>

                </div>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
    </v-container>

    <!-- 스낵바 -->
    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />
    </div>
</template>

<script>
import Input from '@/components/ui/form/FormInput.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import LiveStreamApi from "@/api/livestream/LiveStreamApi";
import { mapActions, mapState } from 'vuex';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";

export default {
    components: {
        Input,
        TextButton,
        CustomSwitch,
        IconButton,
        AppSnackbar,
    },
    data() {
        return {
            stream_name: '',
            stream_name_by_user: '',
            //OnpublishServer: '',
            application: '',
            live_status: '',
            livestatus: false,
            switchStates: {
                publishing: false,
                recording: false,
            },
            recorderState: '',
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
        }
    },
    computed: {
        EMBEDIEDURL() {
            return `${window.location.protocol}//${window.location.host}/player?` + this.HLS;
        },
        HLS() {
            return 'https://' + this.wowzaOrigin + '/' + this.application + '/' + this.stream_name + '.stream/playlist.m3u8';
        },
        ThumbnailUrl() {
            return 'https://' + this.wowzaOrigin + ':8086/thumbnail?application=' + this.application + '&streamname=' + this.stream_name + '.stream&size=640x360&fitmode=letterbox'
        },
        displayStreamName() {
            if (this.stream_name_by_user && this.stream_name_by_user.trim() !== '') {
                return this.stream_name_by_user;
            }
            return this.stream_name;
        },
        isLive() {
            return this.switchStates.publishing;
        },
        isRecording() {
            return this.switchStates.recording;
        },
        OnpublishServer() {
            return 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
        }
    },
    methods: {
        // ...mapActions('livestatus', ['toggleSwitch', 'saveSettings']),
        // async saveChanges() {
        //     const frontUrl = `${window.location.protocol}//${window.location.host}`;
        //     const uuid = this.$route.params.uuid;
        //     const data = {
        //         ip: frontUrl,
        //         uuid: uuid,
        //         publishing: this.switchStates ? this.switchStates.publishing : false,
        //         recording: this.switchStates ? this.switchStates.recording : false,
        //         stream_name: this.stream_name
        //     };
        //     //console.log('data', data);
        //     const success = await this.$store.dispatch('livestatus/saveSettings', data);
        //     if (success) {
        //         this.$emit('settingsSaved');
        //     }
        // },
        goLiveList(){
            this.$router.push('/wowzastream/wowzalivestream_create');
        },
        copyToClipboard(textToCopy) {

            if(!textToCopy){
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('복사할 텍스트가 없습니다.');
                this.snackbarError = true;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.snackbarText = "";
                }, 2000);

                return;
            }

            this.$copyText(textToCopy)
                .then(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('텍스트가 복사되었습니다');
                    this.snackbarError = false;
                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarText = "";
                    }, 2000);
                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        refreshIframe() {
            this.refresh();
            const originalURL = this.EMBEDIEDURL;
            this.$refs.iframe.src = '';
            this.$nextTick(() => {
                this.$refs.iframe.src = originalURL;
                const video =  this.$refs.iframe.contentWindow.document.querySelector('video');
                video.autoplay = true;
                video.play();
            });
        },
        async liveData(uuid) {
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                    uuid: uuid,
                };
                const response = await LiveStreamApi.detailApi(data);
                this.application = response.item.application;
                this.stream_name = response.item.stream_name;
                this.stream_name_by_user = response.item.stream_name_by_user || '';
                this.live_status = response.item.pull_stream_status;
                this.switchStates.publishing = response.item.pull_stream_status === 1;
                // this.switchStates.publishing = response.item.pb_accept == '1';
                // this.switchStates.recording = response.item.record_status == '1';
                this.cname = response.domain;

            } catch (error) {
                console.error('error', error);
            }
        },
        temp() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            if (!video) return;
            video.poster = "/streamon.png";
        },
        resizeVideo() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            const iframeDocument = iframe.contentWindow.document;
            if (!video) return;

            const container = iframe.parentElement;
            const containerWidth = container.offsetWidth;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;

            if (aspectRatio < 1) {
                container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
            } else {
                container.style.paddingBottom = '56.25%';
            }

            video.autoplay = true;
            video.play();

        },
        refresh() {
            const uuid = this.$route.params.uuid;
            this.liveData(uuid);
            this.pullStatus();
        },
        async getApplication() {

            try {
                const response = await LiveStreamApi.getApplicationApi();
                // console.log('res', response.wowza);
                if (response.status === 1) {
                    // const applicationData = response.application;
                    //const wowzaData = response.data.data;
                    //const wowzaOrigin = response.wowza;

                    // this.application = applicationData;
                    //this.wowzaData = wowzaData;
                    this.wowzaOrigin = response.wowza;
                    // this.OnpublishServer = 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
                } else {
                    console.error('Error:', response.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        async toggleSwitch(switchKey) {
            try {
                const newState = !this.switchStates[switchKey];
                if (switchKey === 'recording' && newState && !this.isLiveRunning()) {
                    this.showSnackbarMessage(this.$store.getters.t('메인 라이브를 먼저 시작한 후 녹화를 켤 수 있습니다.'), true);
                    return;
                }

                let response;

                if (switchKey === 'recording') {
                    response = await this.updateRecordingStatus(newState);
                } else if (switchKey === 'publishing') {
                    response = await this.updatePublishingStatus(newState);
                }

                if (response && response.status === 1) {
                    this.switchStates[switchKey] = newState;
                    console.log(`${switchKey} 스위치가 ${newState ? '켜짐' : '꺼짐'}으로 전환됨`);
                    setTimeout(() => {
                        this.pullStatus();
                    }, 2000);
                } else {
                    console.error('Error');
                }
            } catch (error) {
                console.error('Error', error);
            }
        },
        isLiveRunning() {
            if (this.switchStates.publishing) {
                return true;
            }
            const status = this.live_status;
            if (status === null || status === undefined || status === '') {
                return false;
            }
            if (typeof status === 'boolean') {
                return status;
            }
            const numeric = Number(status);
            if (!Number.isNaN(numeric)) {
                return numeric === 1;
            }
            const normalized = String(status).trim().toLowerCase();
            return normalized === 'live' || normalized === 'running' || normalized === 'on';
        },
        showSnackbarMessage(message, isError = false, duration = 2000) {
            this.snackbar = true;
            this.snackbarText = message;
            this.snackbarError = isError;
            setTimeout(() => {
                this.snackbar = false;
                this.snackbarError = false;
                this.snackbarText = "";
            }, duration);
        },
        async updateRecordingStatus(newState) {
            console.log('recording');
            const data = { streamName: this.stream_name, status: newState ? 1 : 0, application: this.application };
            return await LiveStreamApi.updateRecordingOnOffApi(data);
        },
        async updatePublishingStatus(newState) {
            console.log('stream');
            const data = { streamName: this.stream_name, status: newState ? 1 : 0, application: this.application };
            return await LiveStreamApi.updateStreamOnOffApi(data);
        },
        async pullStatus() {
            try {
                const data = {
                    recorderName: this.stream_name,
                    application: this.application
                }
                const response = await LiveStreamApi.checkStatus(data);
                if (response.status === '1') {
                    //레코딩 상태는 on이지만 영상재생에 따른 상태
                    if (response.recorderState === 'Waiting for stream') {
                        this.recorderState = 'wait';
                        this.switchStates.recording = false;
                    } else if (response.recorderState === 'Recording in Progress') {
                        this.recorderState = 'progress';
                        this.switchStates.recording = true;
                    } else {
                        this.recorderState = 'stop';
                        this.switchStates.recording = false;
                    }
                } else if (response.status === '2') {
                    // recorder not found일 때
                    this.recorderState = 'stop';
                    this.switchStates.recording = false;
                }

            } catch (error) {
                console.error('Error', error);
            }
        },

    },
    async beforeMount() {
        const uuid = this.$route.params.uuid;
        await this.getApplication();

        //await this.pullLoadBalancer();
        await this.liveData(uuid);
        this.pullStatus();
    },
    // mounted() {
    //     setInterval(() => {
    //         this.pullStatus();
    //     }, 500000);
    // },
    watch: {
        'switchStates.publishing'(newVal) {
            if (newVal) {
                this.refreshIframe();
            }
        }
    }
}
</script>

<style>
.cont_title {
    margin-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #000;
    font-size: 18px;
}

.tabletitle {
    font-size: 18px;
    padding-bottom: 10px;
}

.left_wraper {
    width: 800px !important;
}

.uniform-gap-32 > .grid-col {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

@media only screen and (max-width: 600px) {
    .lr_wrapper {
        display: block;
    }

    .right_wraper {
        margin: 0px;
    }
}

.right_wraper {
    width: 100%;
    margin-left: 20px;
}

.text_box {
    word-break: break-all;
    color: #888;
    width: 100%;
}

.table_text {
    background: #fff;
}

iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.video-container{
  position:relative;
  width:100%;
  padding-top:56.25%; /* 16:9 */
}
.video-container iframe{
  position:absolute;inset:0;width:100%;height:100%;
}

.thumbnail-wrapper {
    position: relative;
    width: 300px;
    height: 200px;
}

.thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.reco_status {
    line-height: 14px;
    margin-left: 10px;
    padding: 4px 8px 4px 8px;
    border-radius: 2px;
}

.reco_status.recording_on {
    background: #ffe7e7;
    color: #d33333;
}

.reco_status.recording_off {
    background: #f4f4f4;
    color: #696969;
}

.reco_status.recording_waiting {
    background: #fff5df;
    color: #e69b3f;
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.blinking {
    animation: blink 1.3s infinite;
}

.url-info-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.url-block {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  padding-bottom: 12px;

}

.url-block:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.url-label {
  font-weight: 700;
  font-size: 13px;
  color: #374151;
  margin-bottom: 6px;
}

.url-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding-left: 8px;
}

.url-text {
  flex: 1;
  font-size: 12.5px;
  color: #111827;
  word-break: break-all;
}

.mono-ellipsis {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
